import { z } from 'zod'

export const forgotPasswordSchema = z.object({
  cpf: z
    .string()
    .min(1, 'CPF é obrigatório')
    .refine((value) => {
      const cpf = value.replace(/\D/g, '')
      return cpf.length === 11
    }, 'CPF deve conter 11 dígitos')
    .transform((value) => value.replace(/\D/g, '')),
})

export const newPasswordSchema = z
  .object({
    password: z
      .string()
      .min(8, 'Senha deve conter no mínimo 8 caracteres')
      .refine(
        (value) => /[A-Z]/.test(value),
        'Senha deve conter pelo menos uma letra maiúscula',
      )
      .refine(
        (value) => /[a-z]/.test(value),
        'Senha deve conter pelo menos uma letra minúscula',
      )
      .refine(
        (value) => /\d/.test(value),
        'Senha deve conter pelo menos um número',
      )
      .refine(
        (value) => /[!@#$%^&*(),.?":{}|<>]/.test(value),
        'Senha deve conter pelo menos um caractere especial',
      ),
    confirmPassword: z.string().min(1, 'Confirmação de senha é obrigatória'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'As senhas não coincidem',
    path: ['confirmPassword'],
  })

export type ForgotPasswordFormData = z.infer<typeof forgotPasswordSchema>
export type NewPasswordFormData = z.infer<typeof newPasswordSchema>

export type Step = 'forgot-password' | 'code-recovery' | 'new-password'
